const ZOOM_EVENTS = {
  UPDATE: 'update',
  ZOOM_START: 'zoomStart',
  TWO_FINGERS_ZOOM_START: 'twoFingersZoomStart',
  TWO_FINGERS_ZOOM_END: 'twoFingersZoomEnd',
  UPDATED_FROM_THE_BUTTON: 'updateFromTheButton',
};

export { ZOOM_EVENTS };
